import React from 'react';
import {
  Input as _Input,
  Select as _Select,
  Checkbox as AntCheckbox,
  DatePicker as _DatePicker,
  Radio
} from 'antd';
import styled from 'styled-components';

const FormContainer = styled.div`
  ${props => !props.noMargin && 'margin-bottom: 15px;'}
`;

export const FormTitle = styled.p`
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 8px !important;
`;

export const Label = styled.p`
  font-weight: 500;
  margin-bottom: 10px !important;
`;

const Input = styled(_Input)`
  font-family: Montserrat !important;
`;

export const TextInput = props => {
  const { label, className, noMargin, ...restProps } = props;
  return (
    <FormContainer noMargin={noMargin}>
      {label && <Label>{label}</Label>}
      <Input {...restProps} />
    </FormContainer>
  );
};

const { Option } = _Select;
const Select = styled(_Select)`
  width: 100%;
  font-family: Montserrat !important;
`;

export const Dropdown = props => {
  const { label, className, options, noMargin, ...restProps } = props;
  return (
    <FormContainer noMargin={noMargin}>
      {label && <Label>{label}</Label>}
      <Select {...restProps}>
        {options.map(option => <Option key={option.value} value={option.value}>{option.label}</Option>)}
      </Select>
    </FormContainer>
  );
};

export const Checkbox = props => {
  const { label, ...restProps } = props;
  return (
    <AntCheckbox {...restProps}>{label}</AntCheckbox>
  );
};

const AntDatePicker = styled(_DatePicker)`
  width: 100%;
`;

export const DatePicker = props => {
  const { label, noMargin, ...restProps } = props;
  return (
    <FormContainer noMargin={noMargin}>
      {label && <Label>{label}</Label>}
      <AntDatePicker {...restProps} />
    </FormContainer>
  );
};

const RadioStyled = styled(Radio)`
  display: block !important;
  font-family: Montserrat !important;
  margin-bottom: 7px !important;
  &:last-child {
    margin-bottom: 0 !important;
  }
`;

export const RadioGroupButton = props => {
  const { label, noMargin, options, ...restProps } = props;
  return (
    <FormContainer noMargin={noMargin}>
      {label && <Label>{label}</Label>}
      <Radio.Group {...restProps}>
        {options.map(option => <RadioStyled value={option.value}>{option.label}</RadioStyled>)}
      </Radio.Group>
    </FormContainer>
  );
};



// WEBPACK FOOTER //
// ./src/components/Core/Forms.js